import React from 'react';
import styled from 'styled-components';

interface SimpleImageProps {
    width?: string | number;
    height?: string | number;
    src: string;
    alt?: string;
}

interface ImgStyleProps {
    width?: string | number;
    height?: string | number;
}

export const SimpleImage: React.FC<SimpleImageProps> = ({ width, height = 'auto', src, alt }) => {
    return <ImgStyle src={src} width={width} height={height} alt={alt} />;
};

export const ImgStyle = styled.img<ImgStyleProps>`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
`;
